// pages/control/CreateQuote.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useControlAuth } from '../../ControlAuthContext';
import './CreateQuote.css';

const CreateQuote = () => {
  const { user } = useControlAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    client_email: '',
    client_name: '',
    client_category_territory: '',
    comments: '',                    
    status: 'Pending Quote',
    lost_reason: '',
    items: [{ 
      product_sku: '', 
      product_price: '', 
      product_quantity: '', 
      delivery_time: '',
      brand: '' 
    }]
  });

  const addItem = () => {
    setForm(prev => ({
      ...prev,
      items: [...prev.items, { 
        product_sku: '', 
        product_price: '', 
        product_quantity: '', 
        delivery_time: '',
        brand: '' 
      }]
    }));
  };

  const removeItem = (index) => {
    setForm(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };

  const updateItem = (index, field, value) => {
    setForm(prev => {
      const newItems = [...prev.items];
      newItems[index][field] = value;
      return { ...prev, items: newItems };
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!form.client_email) {
      toast.error('Please enter client email');
      return;
    }

    if (form.items.some(item => !item.product_sku || !item.product_quantity)) {
      toast.error('All items must have SKU and quantity');
      return;
    }

    // Validation for Lost Client
    if (form.status === 'Lost Client' && !form.lost_reason.trim()) {
      toast.error('Please enter the reason why the client was lost');
      return;
    }

    try {
      const token = localStorage.getItem('controlToken');
      await axios.post('https://valleyapi-dr9y.onrender.com/api/control/quotes', form, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Quote(s) created successfully');
      navigate('/control/pending-quotes');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error creating quote');
    }
  };

  return (
    <div className="create-quote-container">
      <h2>Create New Quote</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="quote-item-email">
          <label>Client Email</label>
          <input
            type="email"
            value={form.client_email}
            onChange={e => setForm({ ...form, client_email: e.target.value })}
            placeholder="cliente@ejemplo.com"
            required
          />
        </div>

        <div className="quote-item-email">
          <label>Client Name</label>
          <input
            type="text"
            value={form.client_name}
            onChange={e => setForm({ ...form, client_name: e.target.value })}
            placeholder="Enter Client Name"
          />
        </div>

        <div className="quote-item-email">
          <label>Client/Category/Territory</label>
          <input
            type="text"
            value={form.client_category_territory}
            onChange={e => setForm({ ...form, client_category_territory: e.target.value })}
            placeholder="Enter Client/Category/Territory (e.g. Mexico - North)"
          />
        </div>

        {/* Status Dropdown */}
        <div className="quote-item-email">
          <label>Status</label>
          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            style={{ width: '100%', padding: '10px', fontSize: '14px' }}
            required
          >
            <option value="Quoted Submitted">Quoted Submitted</option>
            <option value="Pending Quote">Pending Quote</option>
            <option value="PO">PO</option>
            <option value="Lost Client">Lost Client</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Sent">Sent</option>
          </select>
        </div>

        {/* Conditional Lost Reason */}
        {form.status === 'Lost Client' && (
          <div className="quote-item-email" style={{ marginTop: '15px' }}>
            <label style={{ color: '#d32f2f' }}>Motivo de pérdida del cliente (requerido)</label>
            <textarea
              name="lost_reason"
              value={form.lost_reason}
              onChange={handleChange}
              placeholder="Explain why the client was lost (e.g. price too high, competitor won, etc.)"
              rows={3}
              style={{ width: '100%', resize: 'vertical', padding: '10px', fontSize: '14px', borderColor: '#d32f2f' }}
              required
            />
          </div>
        )}

        <h3>Items</h3>
        {form.items.map((item, index) => (
          <div key={index} className="quote-item">
            <input
              placeholder="Product SKU"
              value={item.product_sku}
              onChange={e => updateItem(index, 'product_sku', e.target.value)}
              required
            />
            <input
              placeholder="Brand"
              value={item.brand || ''}
              onChange={e => updateItem(index, 'brand', e.target.value)}
            />
            <input
              type="number"
              step="0.01"
              placeholder="Price (optional)"
              value={item.product_price}
              onChange={e => updateItem(index, 'product_price', e.target.value)}
            />
            <input
              type="number"
              placeholder="Quantity"
              value={item.product_quantity}
              onChange={e => updateItem(index, 'product_quantity', e.target.value)}
              required
            />
            <input
              placeholder="Delivery Time"
              value={item.delivery_time}
              onChange={e => updateItem(index, 'delivery_time', e.target.value)}
            />
            {form.items.length > 1 && (
              <button type="button" onClick={() => removeItem(index)}>Remove</button>
            )}
          </div>
        ))}

        <button type="button" onClick={addItem} className="btn-add-item">
          + Add Another Product
        </button>

        {/* Campo Comments mejorado */}
        <div className="quote-item-email" style={{ marginTop: '20px' }}>
          <label>Comments / Notas adicionales</label>
          <textarea
            name="comments"
            value={form.comments}
            onChange={handleChange}
            placeholder="Enter any additional comments, observations or special instructions..."
            rows={4}
            style={{ width: '100%', resize: 'vertical', padding: '10px', fontSize: '14px' }}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-submit">Create Quote</button>
          <button type="button" onClick={() => navigate('/control/pending-quotes')}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateQuote;